












import Vue from 'vue'
import EventEntity from '@/entities/Event'

export default Vue.extend({
  props: {
    eventData: {
      type: Object as () => EventEntity,
      required: true
    }
  }
})
